<script lang="ts">
  type Direction = "right" | "down" | "left" | "up";
  export let direction: Direction = "right";
</script>

<svg
  {...$$restProps}
  viewBox="0 0 9 12"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  class:down={direction === "down"}
  class:left={direction === "left"}
  class:up={direction === "up"}
>
  <path d="M8.54922 6.00002L0.449219 11.4L0.449219 0.600024L8.54922 6.00002Z" fill="currentColor" />
</svg>

<style>
  .down {
    transform: rotate(90deg);
  }

  .left {
    transform: rotate(180deg);
  }

  .up {
    transform: rotate(270deg);
  }
</style>
